<template>
    <div class="dashboard-home">
        <!-- Stats Cards -->
        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-icon">
                    <i class="fa-solid fa-briefcase"></i>
                </div>
                <div class="stat-content">
                    <h3>{{ stats.totalProjects }}</h3>
                    <p>Proyectos Totales</p>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon">
                    <i class="fa-solid fa-eye"></i>
                </div>
                <div class="stat-content">
                    <h3>{{ stats.totalViews }}</h3>
                    <p>Visualizaciones</p>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon">
                    <i class="fa-solid fa-chart-line"></i>
                </div>
                <div class="stat-content">
                    <h3>{{ stats.avgConversion }}%</h3>
                    <p>Conversión Promedio</p>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon">
                    <i class="fa-solid fa-clock"></i>
                </div>
                <div class="stat-content">
                    <h3>{{ stats.recentProjects }}</h3>
                    <p>Proyectos Recientes</p>
                </div>
            </div>
        </div>

        <!-- Recent Projects -->
        <div class="recent-projects">
            <div class="section-header">
                <h2>Proyectos Recientes</h2>
                <router-link to="/dashboard/portfolio" class="view-all-btn">
                    Ver Todos
                </router-link>
            </div>

            <div class="projects-grid">
                <div v-for="project in recentProjects" :key="project.id" class="project-card">
                    <div class="project-image">
                        <img :src="project.image_url" :alt="project.title">
                        <div class="project-overlay">
                            <button class="edit-btn" @click="editProject(project)">
                                <i class="fa-solid fa-edit"></i>
                            </button>
                        </div>
                    </div>
                    <div class="project-info">
                        <h4>{{ project.title }}</h4>
                        <p>{{ project.subtitle }}</p>
                        <div class="project-meta">
                            <span class="category">{{ project.category_name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Quick Actions -->
        <div class="quick-actions">
            <h2>Acciones Rápidas</h2>
            <div class="actions-grid">
                <button class="action-btn" @click="addNewProject">
                    <i class="fa-solid fa-plus"></i>
                    <span>Nuevo Proyecto</span>
                </button>
                <button class="action-btn" @click="exportData">
                    <i class="fa-solid fa-download"></i>
                    <span>Exportar Datos</span>
                </button>
                <button class="action-btn" @click="backupData">
                    <i class="fa-solid fa-save"></i>
                    <span>Crear Backup</span>
                </button>
                <button class="action-btn" @click="viewAnalytics">
                    <i class="fa-solid fa-chart-bar"></i>
                    <span>Ver Analytics</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '../config/api.js';

export default {
    name: 'DashboardHome',
    data() {
        return {
            stats: {
                totalProjects: 0,
                totalViews: '0',
                avgConversion: 0,
                recentProjects: 0
            },
            recentProjects: [],
            loading: true,
            error: null
        }
    },
    async mounted() {
        await this.loadData();
    },
    methods: {
        async loadData() {
            try {
                this.loading = true;
                this.error = null;
                
                console.log('🚀 Cargando datos del dashboard home...');
                
                // Cargar proyectos y estadísticas en paralelo
                const [projectsResponse, statsResponse] = await Promise.all([
                    apiService.getProjects(),
                    apiService.getProjectStats()
                ]);
                
                console.log('📊 Respuesta de proyectos:', projectsResponse);
                console.log('📈 Respuesta de estadísticas:', statsResponse);
                
                if (projectsResponse && projectsResponse.success) {
                    // Obtener los 3 proyectos más recientes (por ID)
                    this.recentProjects = projectsResponse.data
                        .sort((a, b) => b.id - a.id)
                        .slice(0, 3);
                    
                    this.stats.totalProjects = projectsResponse.data.length;
                    console.log('✅ Proyectos cargados:', this.recentProjects.length);
                } else {
                    const errorMsg = projectsResponse?.error || 'Error al cargar proyectos';
                    console.error('❌ Error en respuesta de proyectos:', projectsResponse);
                    throw new Error(errorMsg);
                }
                
                if (statsResponse && statsResponse.success) {
                    this.stats.recentProjects = statsResponse.data.recent_projects || 0;
                    console.log('✅ Estadísticas cargadas');
                } else {
                    console.warn('⚠️ No se pudieron cargar las estadísticas');
                }
                
            } catch (error) {
                console.error('❌ Error cargando datos:', error);
                this.error = `Error al cargar los datos: ${error.message}`;
            } finally {
                this.loading = false;
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('es-ES', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        },
        editProject(project) {
            this.$router.push({
                name: 'PortfolioManagement',
                query: { edit: project.id }
            });
        },
        addNewProject() {
            this.$router.push('/dashboard/portfolio');
        },
        exportData() {
            // Implementar exportación de datos
            console.log('Exportando datos...');
        },
        backupData() {
            // Implementar backup
            console.log('Creando backup...');
        },
        viewAnalytics() {
            // Implementar analytics
            console.log('Abriendo analytics...');
        }
    }
}
</script>

<style lang="scss" scoped>
.dashboard-home {
    .stats-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 20px;
        margin-bottom: 40px;

        .stat-card {
            background: white;
            border-radius: 12px;
            padding: 25px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            display: flex;
            align-items: center;
            gap: 20px;
            transition: transform 0.3s ease;

            &:hover {
                transform: translateY(-5px);
            }

            .stat-icon {
                width: 60px;
                height: 60px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 24px;
                color: white;

                &:nth-child(1) {
                    background: linear-gradient(135deg, #1f8cc6, #167aad);
                }

                &:nth-child(2) {
                    background: linear-gradient(135deg, #f08908, #e67e22);
                }

                &:nth-child(3) {
                    background: linear-gradient(135deg, #27ae60, #2ecc71);
                }

                &:nth-child(4) {
                    background: linear-gradient(135deg, #9b59b6, #8e44ad);
                }
            }

            .stat-content {
                h3 {
                    margin: 0 0 5px 0;
                    font-size: 28px;
                    font-weight: 600;
                    color: #333;
                }

                p {
                    margin: 0;
                    color: #666;
                    font-size: 14px;
                }
            }
        }
    }

    .recent-projects {
        background: white;
        border-radius: 12px;
        padding: 30px;
        margin-bottom: 40px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

        .section-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 25px;

            h2 {
                margin: 0;
                font-size: 20px;
                font-weight: 600;
                color: #333;
            }

            .view-all-btn {
                color: #1f8cc6;
                text-decoration: none;
                font-weight: 500;
                font-size: 14px;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .projects-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 20px;

            .project-card {
                border: 1px solid #e1e5e9;
                border-radius: 8px;
                overflow: hidden;
                transition: all 0.3s ease;

                &:hover {
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
                }

                .project-image {
                    position: relative;
                    height: 150px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .project-overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        opacity: 0;
                        transition: opacity 0.3s ease;

                        .edit-btn {
                            background: #1f8cc6;
                            color: white;
                            border: none;
                            padding: 8px 12px;
                            border-radius: 6px;
                            cursor: pointer;
                            font-size: 14px;

                            &:hover {
                                background: #167aad;
                            }
                        }
                    }

                    &:hover .project-overlay {
                        opacity: 1;
                    }
                }

                .project-info {
                    padding: 15px;

                    h4 {
                        margin: 0 0 5px 0;
                        font-size: 16px;
                        font-weight: 600;
                        color: #333;
                    }

                    p {
                        margin: 0 0 10px 0;
                        font-size: 14px;
                        color: #666;
                        line-height: 1.4;
                    }

                    .project-meta {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .category {
                            background: #e3f2fd;
                            color: #1f8cc6;
                            padding: 4px 8px;
                            border-radius: 12px;
                            font-size: 12px;
                            font-weight: 500;
                        }

                        .date {
                            color: #999;
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }

    .quick-actions {
        background: white;
        border-radius: 12px;
        padding: 30px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

        h2 {
            margin: 0 0 25px 0;
            font-size: 20px;
            font-weight: 600;
            color: #333;
        }

        .actions-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 15px;

            .action-btn {
                display: flex;
                align-items: center;
                gap: 12px;
                background: #f8f9fa;
                border: 2px solid #e1e5e9;
                padding: 15px 20px;
                border-radius: 8px;
                cursor: pointer;
                transition: all 0.3s ease;
                font-size: 14px;
                font-weight: 500;
                color: #333;

                &:hover {
                    background: #1f8cc6;
                    border-color: #1f8cc6;
                    color: white;
                    transform: translateY(-2px);
                }

                i {
                    font-size: 16px;
                }
            }
        }
    }
}

// Dark theme
body.dark-theme .dashboard-home {
    .stats-grid {
        .stat-card {
            background: #2b2a2a;

            .stat-content {
                h3 {
                    color: #ffffff;
                }

                p {
                    color: #ccc;
                }
            }
        }
    }

    .recent-projects, .quick-actions {
        background: #2b2a2a;

        .section-header {
            h2 {
                color: #ffffff;
            }
        }

        .projects-grid {
            .project-card {
                border-color: #444;

                .project-info {
                    h4 {
                        color: #ffffff;
                    }

                    p {
                        color: #ccc;
                    }

                    .project-meta {
                        .category {
                            background: #1f2122;
                            color: #f08908;
                        }

                        .date {
                            color: #999;
                        }
                    }
                }
            }
        }

        .actions-grid {
            .action-btn {
                background: #1f2122;
                border-color: #444;
                color: #ccc;

                &:hover {
                    background: #f08908;
                    border-color: #f08908;
                    color: white;
                }
            }
        }
    }
}

// Responsive
@media (max-width: 768px) {
    .dashboard-home {
        .stats-grid {
            grid-template-columns: 1fr;
        }

        .recent-projects {
            .projects-grid {
                grid-template-columns: 1fr;
            }
        }

        .quick-actions {
            .actions-grid {
                grid-template-columns: 1fr;
            }
        }
    }
}
</style> 